<ng-container *transloco="let t">
  <ng-container *ngFor="let menu of menuData$ | withLoader | async; let i = index">
    <ng-container *ngIf="menu.links.length <= 0; else subMenu">
      <app-prepared-link
        *ngIf="menu.target.targetType === 'isophi_management' || menu.target.targetType === 'isophi_teacher'; else otherLinks"
        [anchorClass]="'dropdown-item'"
        [preparedLink]="menu.target.targetType | prepareLinks"
      >
        {{ menu.target.name }}
      </app-prepared-link>
      <ng-template #otherLinks>
        <ng-container
          *ngIf="
            (isSkKindergarten$ | async) === false && (isSchool$ | async) === false && menu.target.targetType === 'teacher_management';
            else link
          "
        >
          <a class="dropdown-item" [href]="managementAddUserUrl.url" [target]="managementAddUserUrl.target">
            <span>{{ menu.target.name }}</span>
          </a>
        </ng-container>

        <ng-template #link>
          <app-prepared-link [anchorClass]="'dropdown-item'" [preparedLink]="menu.target.targetType | prepareLinks">
            <span>{{ menu.target.name }}</span>
          </app-prepared-link>
        </ng-template>
      </ng-template>
    </ng-container>

    <ng-template #subMenu>
      <div (click)="preventMenuClose($event)" class="accordion accordion-flush" [id]="'accordionFlush_' + i">
        <div class="accordion-item">
          <h5 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#data_' + i"
              aria-expanded="false"
              [attr.aria-controls]="'data_' + i"
            >
              {{ menu.target.name }}
            </button>
          </h5>
          <div
            [id]="'data_' + i"
            class="accordion-collapse collapse"
            aria-labelledby="flush"
            [attr.data-bs-parent]="'#accordionFlush_' + i"
          >
            <div class="accordion-body">
              <ng-container *ngFor="let subMenuData of menu.links">
                <app-prepared-link
                  *ngIf="
                    subMenuData.targetType === 'auto_evaluation' ||
                      subMenuData.targetType === 'smart_promo' ||
                      subMenuData.targetType === 'isophi_management';
                    else otherLinks
                  "
                  [anchorClass]="'dropdown-item'"
                  [preparedLink]="subMenuData.targetType | prepareLinks"
                >
                  {{ subMenuData.name }}
                </app-prepared-link>

                <ng-template #otherLinks>
                  <app-prepared-link
                    [anchorClass]="'dropdown-item'"
                    [preparedLink]="subMenuData.targetType | prepareLinks"
                    [queryParams]="
                      subMenuData.filteredProductType
                        ? { product: subMenuData.filteredProductType === 'test' ? productType.DAD_TEST : subMenuData.filteredProductType }
                        : subMenuData.productId
                        ? { material: subMenuData.productId }
                        : subMenuData.codename
                        ? { codename: subMenuData.codename }
                        : undefined
                    "
                  >
                    {{ subMenuData.name }}
                  </app-prepared-link>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
